import {reportRoute} from "@/page/report/route";

export default [
  ...reportRoute,
  /**
   * @param query.index
   */
  {
    path: '/report',
    component: () => import('../page/report/index')
  },
  /**
   * @param query.index
   */
  {
    path: '/report/type',
    component: () => import('../page/report/type')
  },
  /**
   * @param query.index
   * @param query.compatId
   * @param query.patCard
   * @param cache.compatCache
   */
  {
    path: '/report/list',
    meta: {keepAlive: false},
    component: () => import('../page/report/list')
  },

  /**
   * 检查报告详情
   * @param cache.compatCache
   * @param cache.examinationCache
   */
  {
    path: '/report/detail/examination',
    component: () => import('../page/report/detail/examination')
  },
  /**
   * 检验报告详情
   * @param cache.compatCache
   * @param cache.inspectCache
   */
  {
    path: '/report/detail/inspect',
    component: () => import('../page/report/detail/inspect')
  },


  /**
   *
   *  @param cache.testCache
   */
  {
    path: '/report/detail/test',
    component: () => import('../page/report/detail/test')
  },
  /**
   * 数字影像支付
   * accessionNumber
   * hospitalId
   * @param cache.testCache
   */
  {
    path: '/report/pay',
    component: () => import('../page/report/pay')
  },
  /**
   * 数字影像详情
   * accessionNumber
   * hospitalId
   * newUrl 是否启用新地址
   * @param cache.testCache
   */
  {
    path: '/report/detail/image',
    component: () => import('../page/report/detail/image')
  },
  /**
   * @param cache.introscopeCache
   */
  {
    path: '/report/detail/introscope',
    component: () => import('../page/report/detail/introscope')
  },
  /**
   * @param cache.introscopeCache
   */
  {
    path: '/report/detail/ecg',
    component: () => import('../page/report/detail/ecg')
  },

  {
    path: '/report/detail/ecg/image',
    component: () => import('../page/report/detail/ecg/image')
  },

  {
    path: '/report/detail/ecg/pdf',
    component: () => import('../page/report/detail/ecg/pdf')
  },
  /**
   * 体检咨询首页
   * @param params.id
   * @param cache.testCache
   */
  {
    path: '/report/consult/test',
    component: () => import('../page/report/consult/test')
  },

  /**
   *
   * @param query.consultType(team||pic)
   * @param params.id
   * @param cache.testCache
   */
  {
    path: '/report/consult/:id',
    component: () => import('../page/report/consult')
  },
  /**
   * @param params.id
   * @param cache.introscopeCache
   */
  {
    path: '/report/consult/:id/introscope',
    component: () => import('../page/report/consult')
  },
  /**
   * 报告咨询
   * @desc 检验报告，检查报告，内镜报告
   * @param params.id
   * @param cache.introscopeCache
   */
  {
    path: '/report/consult/:id/report',
    component: () => import('../page/report/consult')
  }


]



// WEBPACK FOOTER //
// ./src/router/report.js